export const BundleProductLines = {
  PURE_OTT: "bundle_ott",
  FTTH: "bundle_ftth",
  POSTPAID_OTT: "bundle_post_ott",
};
